module.exports = __webpack_public_path__ + "img/icon-update-dark.5b00bc41.svg";